import { render } from "./StartOrderModal.vue?vue&type=template&id=0138ff74"
import script from "./StartOrderModal.vue?vue&type=script&lang=js"
export * from "./StartOrderModal.vue?vue&type=script&lang=js"

import "./StartOrderModal.vue?vue&type=style&index=0&id=0138ff74&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__